<template>
  <div class="sign-in" :class="{ step: isStep }">
    <Captcha v-if="showCaptcha" @hideCaptcha="hideCaptcha" @onVerify="verifyToken" />

    <form-layout
      title-type="h2"
      :main-title="title"
      :mbile-title="mobileTitle"
      :title="$t('auth.authorization')"
      :close="closeHandler"
      :submit-text="$t('actions.createAccount')"
      :show-header="true"
      :show-back="false"
      :hide-footer="!isStep"
      @back="backHandler"
      @submit="createAccountHandler"
    >
      <div class="sign-in__main">
        <Loader v-if="isLoading" />

        <div class="sign-in__main__form">
          <Input
            v-model="values.login"
            name="login"
            :error="errors.login.message"
            :state="errors.login.message ? 'error' : 'default'"
            :placeholder="$t('auth.inputs.loginOrEmail')"
            icon="/SignIn/login.svg"
            @input="validateLogin"
            @enter="validateCaptcha"
          />
          <Input
            v-model="values.password"
            name="password"
            :error="errors.password.message"
            :state="errors.password.message ? 'error' : 'default'"
            :placeholder="$t('auth.inputs.password')"
            icon="/SignIn/lock.svg"
            type="password"
            :password="true"
            @input="validatePassword"
            @enter="validateCaptcha"
          />
        </div>

        <div class="sign-in__main__footer">
          <p
            class="sign-in__main__forget-pas"
            @click="$store.commit('stateSignIn'), $store.commit('stateForgetPassword')"
          >
            {{ $t('auth.forget') }}
          </p>
          <Button left-icon="/SignIn/logout.svg" @click="validateCaptcha">
            {{ $t('actions.login') }}
          </Button>
            <p class="sign-in__main__or">{{ $t('general.or') }}</p>
            <div class="sign-in__main__social-buttons">
              <vk-button class="sign-in__main__btn-vk" @auth-success="handleSocialAuthSuccess" />
              <google-button class="sign-in__main__btn-google" @auth-success="handleSocialAuthSuccess" />
              <telegram-button class="sign-in__main__btn-tg" @auth-success="handleSocialAuthSuccess" />
              <apple-button class="sign-in__main__btn-apple" @auth-success="handleSocialAuthSuccess" />
            </div>
        </div>
      </div>
    </form-layout>
    <div v-if="!isStep" class="sign-in__welcome">
      <div class="sign-in__welcome__body">
        <p class="sign-in__welcome__title">{{ $t('auth.welcome.title') }}</p>
        <p class="sign-in__welcome__inf">{{ $t('auth.welcome.content') }}</p>

        <Button class="sign-in__welcome__btn" left-icon="/base/plus.svg" @click="createAccountHandler">
          {{ $t('actions.createAccount') }}
        </Button>
      </div>

      <div class="sign-in__welcome__background" />
    </div>
    <Button class="sign-in__create-btn" left-icon="/base/plus.svg" @click="createAccountHandler">
      {{ $t('actions.createAccount') }}
    </Button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loader from '@/components/LoaderBar/LoaderBar'
import Captcha from '@/components/Captcha/Captcha'
import telegramButton from '@/components/telegram-button'
import vkButton from '@/components/vk-button'
import googleButton from '@/components/google-button'
import appleButton from '@/components/apple-button'
// import * as intercom from '@/utils/intercom'
import Input from '@/components/Base/Input/Input.vue'
import Button from '@/components/Base/Button/Button.vue'
import FormLayout from '@/components/Base/FormLayout/FormLayout.vue'
import { validatePassword } from '@/utils/validate'

export default {
  name: 'SignIn',
  components: {
    FormLayout,
    Button,
    Input,
    Loader,
    Captcha,
    telegramButton,
    vkButton,
    googleButton,
    appleButton
  },
  props: {
    isStep: {
      type: Boolean,
      default: false
    },
    isSuperPass: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      showCaptcha: false,
      vkUrl: '',
      login: '',
      password: '',
      values: {
        login: '',
        password: ''
      },
      token: '',
      errors: {
        login: {
          status: '',
          show: '',
          message: ''
        },
        password: {
          status: '',
          show: '',
          message: ''
        }
      }
    }
  },
  created() {
    fetch('https://users.backend-pier.com/api/v1/user/vkurl')
      .then(res => res.json())
      .then(data => {
        this.vkUrl = data.vk_url
      })
      .catch(err => console.log(err))
  },
  computed: {
    ...mapGetters(['language']),
    bannerHide() {
      return window.innerWidth < 1600 || window.innerHeight < 800 || this.isStep
    },
    title() {
      if (!this.isStep) return
      return this.isSuperPass ? this.$t('superPass.purchase.title') : this.$t('transfer.title')
    },
    mobileTitle() {
      if (!this.isStep) return
      return this.isSuperPass ? this.$t('superPass.purchase.title') : this.$t('transfer.titleMobile')
    }
  },
  methods: {
    hideCaptcha() {
      this.showCaptcha = false
    },
    verifyToken(token) {
      this.hideCaptcha()
      this.token = token
      this.signIn()
    },
    validateCaptcha() {
      const isValidLogin = this.validateLogin()
      const isValidPassword = this.validatePassword()

      if (isValidLogin && isValidPassword) this.showCaptcha = true
    },
    signIn() {
      if (!this.token) return
      this.isLoading = true

      this.validateLogin()
      this.validatePassword()

      let error = false

      Object.keys(this.errors).forEach(key => {
        if (this.errors[key].status === false) {
          error = true
        }
      })

      if (error) {
        this.isLoading = false
        return
      }

      const requestBody = JSON.stringify({
        login: this.values.login,
        password: this.values.password,
        ycaptcha: this.token
      })

      const requestHeaders = new Headers({
        'Content-Type': 'application/json'
      })

      const requestParams = {
        method: 'POST',
        body: requestBody,
        headers: requestHeaders
      }

      const codes = {
        1: this.$t('auth.errors.checkEmail'),
        2: this.$t('auth.errors.checkPassword')
      }

      fetch('https://users.backend-pier.com/api/v1/user/login', requestParams)
        .then(res => res.json())
        .then(data => {
          this.isLoading = false

          if (data.error_codes) {
            let errorMessage
            Object.keys(data.error_codes).forEach(key => {
              if (!data.error_codes[key].length) return

              let newKey = key
              if (key === 'email') {
                newKey = 'login'
              }

              if (!this.errors[newKey]) return

              this.errors[newKey].status = false
              this.errors[newKey].show = true
              this.errors[newKey].message = codes[data.error_codes[key][0]]
              errorMessage = codes[data.error_codes[key][0]]
            })

            this.$analytics.send('login_error', {
              type: 'login',
              method: 'email',
              message: errorMessage
            })
          } else {
            this.isStep ? this.$emit('success') : this.$store.commit('stateSignIn')
            this.$store.dispatch('signIn', data)
            // intercom.authCallback.call(this)

            this.$analytics.send('login', {
              type: 'login',
              method: 'email',
              user_id: data.data?.user_id
            })

            this.$analytics.setUser(data.data?.user_id)
          }
        })
        .catch(err => console.log(err))
    },
    eye(el) {
      const icon = document.querySelector(`#${el}`)
      const input = icon.parentElement.querySelector('input')
      if (icon.src.includes('close-eye')) {
        icon.src = require('@/assets/images/SignIn/open-eye.svg')
        input.type = 'text'
      } else {
        icon.src = require('@/assets/images/SignIn/close-eye.svg')
        input.type = 'password'
      }
      return false
    },
    validateLogin() {
      let errorMessage = ''
      let emailState = true

      if (this.values.login.length === 0) {
        errorMessage = this.$t('auth.errors.empty')
        emailState = false
      } else {
        errorMessage = ''
        emailState = true
      }

      this.errors.login.status = emailState
      this.errors.login.show = !emailState
      this.errors.login.message = errorMessage

      return !errorMessage
    },
    validatePassword() {
      let errorMessage = ''
      let passwordState = true

      if (!this.values.password.length) {
        errorMessage = this.$t('auth.errors.empty')
        passwordState = false
      } else if (this.values.password.length < 6 || this.values.password.length > 18) {
        errorMessage = this.$t('auth.errors.passwordIsTooSmall')
        passwordState = false
      } else if (validatePassword(this.values.password) === false) {
        errorMessage = this.$t('auth.errors.oneUppercase')
        passwordState = false
      }
      this.errors.password.status = passwordState
      this.errors.password.show = !passwordState
      this.errors.password.message = errorMessage

      return passwordState
    },
    closeHandler() {
      if (this.isStep) {
        this.$emit('close')
        return
      }
      this.$store.commit('stateSignIn')
    },
    createAccountHandler() {
      if (this.isStep) {
        this.$emit('createAccount')
        return
      }
      this.$store.commit('stateSignIn')
      this.$store.commit('stateSignUp')
    },
    backHandler() {
      if (this.isStep) {
        this.$emit('back')
      }
    },
    handleSocialAuthSuccess() {
      // Закрываем модалку после успешной авторизации через соцсети
      // Используем ту же логику что и при обычной авторизации (строка 253)
      this.isStep ? this.$emit('success') : this.$store.commit('stateSignIn')
    }
  }
}
</script>
<style lang="scss">
@import './signin';
</style>
